module.exports = __webpack_public_path__ + "img/onboarding-icon-books.b62d199a.svg";